import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { CreditCard } from 'lucide-react';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import { useSEO } from '../hooks/useSEO';

const CURRENCIES = [
  {
    code: 'PLN',
    flag: '🇵🇱',
    symbol: 'zł',
    href: 'https://donate.stripe.com/6oUfZg3Q7cWr56paVt7Zu00',
  },
  {
    code: 'USD',
    flag: '🇺🇸',
    symbol: '$',
    href: 'https://donate.stripe.com/dRmcN4dqH3lReGZ0gP7Zu01',
  },
  {
    code: 'EUR',
    flag: '🇪🇺',
    symbol: '€',
    href: 'https://donate.stripe.com/cNi8wOfyPbSnaqJ2oX7Zu02',
  },
  {
    code: 'CHF',
    flag: '🇨🇭',
    symbol: '₣',
    href: 'https://donate.stripe.com/eVqfZg2M3e0v56p6Fd7Zu03',
  },
];

export default function DonateCurrency() {
  const { t } = useLanguage();
  useSEO({
    title: 'Donate — Select Currency',
    description:
      'Choose your preferred currency to make a secure online donation to GRAWEO Charitable Foundation and support our humanitarian mission.',
  });

  return (
    <div className="bg-white min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-graweo-chocolate to-graweo-olive text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <CreditCard className="w-16 h-16 mx-auto mb-6 opacity-90" />
          <h1 className="text-4xl sm:text-5xl font-bold font-manrope mb-6">
            {t('currency_select_title')}
          </h1>
          <p className="text-xl text-gray-100 max-w-2xl mx-auto">
            {t('currency_select_subtitle')}
          </p>
        </div>
      </section>

      {/* Currency Selection */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {CURRENCIES.map((currency) => (
              <a
                key={currency.code}
                href={currency.href}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
              >
                <Card hover className="p-8 text-center cursor-pointer">
                  <div className="text-5xl mb-4">{currency.flag}</div>
                  <div className="text-3xl font-bold font-manrope text-gray-900 mb-1">
                    {currency.symbol}
                  </div>
                  <div className="text-xl font-semibold text-gray-700 mb-6">
                    {currency.code}
                  </div>
                  <Button variant="primary" className="w-full">
                    {t('currency_donate_button')}
                  </Button>
                </Card>
              </a>
            ))}
          </div>

          <p className="text-center text-gray-500 mt-10 text-sm">
            {t('currency_stripe_note')}
          </p>
        </div>
      </section>
    </div>
  );
}
